import type { ManagerClass, ManagerClassTeacher, RawGroup, RawGroupTutor } from './interfaces'

/** Builds the URL for a single project. */
export const buildProjectUrl = (projectId: string): string => `/projects/${projectId}`

/** Normalizes a raw tutor into the teacher display shape. */
const toTeacher = (raw: RawGroupTutor): ManagerClassTeacher => ({
  id: String(raw.id ?? ''),
  name: raw.name ?? '',
})

/** Maps a raw group (groups route contract) into the dashboard class shape. */
export const toManagerClass = (raw: RawGroup): ManagerClass => ({
  id: String(raw.id ?? ''),
  name: raw.name ?? '',
  studentsCount: raw.studentsCount ?? 0,
  teachers: Array.isArray(raw.tutors) ? raw.tutors.map(toTeacher) : [],
})
